import '../../Reports/reports.scss';

import * as React from 'react';
import { Col, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { hideUSTModal } from '../../../actions/modalActions';
import { IDailyForms, IHistory } from '../../../interfaces';
import { PlantModel } from '../../../model/PlantModel';
import { getAllPlantsByRegion } from '../../../services/plantService';
import { BasePage } from '../../reusableComponents/BasePage';
import { PieChart } from '../../reusableComponents/ChartComponents/PieChart';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { ListPage } from '../../reusableComponents/ListPage';
import { ListFooter } from './ListFooter';
import { ListItem } from './ListItem';

export interface SummaryReportsProps {
    instances: PlantModel[];
    dailyForms: IDailyForms;
    showUSTModal: boolean;
    formType: string;
    history: IHistory;
    userId: string;
    selectedDate: string;
    formInstance: PlantModel;
}

export class SummaryReportsImpl extends React.Component<SummaryReportsProps, {}> {

    promise = async () => {
        await getAllPlantsByRegion(this.props.userId);
    }

    handleFooterYes = () => {
        const { formInstance: { props: { PlantId, Plant_Region } }, selectedDate, formType } = this.props;
        this.props.history.push(`/monthly-checklist-form/${formType}/${PlantId}/${Plant_Region}/${selectedDate}`);
        hideUSTModal();
    }

    handleFooterNo = () => {
        const { formInstance: { props: { PlantId, Plant_Region } }, selectedDate, formType } = this.props;
        this.props.history.push(`/monthly-checklist-form/${formType}/${PlantId}/${Plant_Region}/${selectedDate}`);
        hideUSTModal();
    }

    renderModal = () => {
        return <Modal
            show={this.props.showUSTModal}
            onHide={() => hideUSTModal()}
            container={this}
            className="argos-modal"
            aria-labelledby="contained-modal-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title">
                    Select Form Type
          </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Is this a corrective action follow-up form?
            </Modal.Body>
            <Modal.Footer>
                <FormFooter
                    submitLabel="Yes"
                    cancelLabel="No"
                    onSubmit={this.handleFooterYes}
                    onCancel={this.handleFooterNo}
                />
            </Modal.Footer>
        </Modal>;
    }

    render() {
        const { instances } = this.props;
        return (
            <BasePage className="list-page-base" pageTitle="Reports Summary" >
                {this.renderModal()}
                <ListPage
                    height="71vh"
                    instances={instances}
                    listItemComponent={ListItem}
                    searchBy={['State', 'Plant_Region', 'PlantId']}
                    instanceOf={'plantInfo'}
                    pageHeadings={['#', 'State', 'Region', 'PlantID']}
                    promise={this.promise}
                    cols={[2, 3, 4, 3]}
                    searchPlaceHolder="Enter state, region or plant id to search..."
                    emptyListMessage="No plants found"
                    listFooter={ListFooter}
                />
            </BasePage>
        );
    }
}

export function mapStateToProps(state) {
    const instances = PlantModel.list(state);
    const showUSTModal = state.modal.get('showUSTModal');
    const formType = state.modal.get('formType');
    const formInstance = state.modal.get('formInstance');
    const selectedDate = state.modal.get('selectedDate');
    const userId = state.login.get('UniqueId');
    return {
        userId, instances, showUSTModal, formType, selectedDate, formInstance
    };
}

export const SummaryReportsSlider =
    withRouter(connect<{}, {}, SummaryReportsProps>(mapStateToProps)(SummaryReportsImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Summary/ListPage/SummaryReportsSlider.tsx